import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { token } = await adminLogin(form.username, form.password);
      localStorage.setItem("ark_admin_token", token);
      navigate("/admin");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--color-bg-soft)" }}>
      <div className="bg-white border border-gray-100 p-10 w-full max-w-sm shadow-sm">
        <div className="text-center mb-8">
          <div
            className="text-xl tracking-widest font-bold text-gray-900"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            ARK DESIGN
          </div>
          <div className="text-[9px] tracking-[0.35em] uppercase text-gray-400 mb-6">
            INTERNATIONAL
          </div>
          <div className="text-xs tracking-widest uppercase text-gray-400">Admin Login</div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-xs tracking-widest uppercase text-gray-500 block mb-2">
              Username
            </label>
            <input
              type="text"
              required
              value={form.username}
              onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
              className="w-full border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-gray-900 transition-colors"
            />
          </div>
          <div>
            <label className="text-xs tracking-widest uppercase text-gray-500 block mb-2">
              Password
            </label>
            <input
              type="password"
              required
              value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              className="w-full border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-gray-900 transition-colors"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gray-900 text-white text-xs tracking-widest uppercase py-3 hover:bg-gray-700 transition-colors disabled:opacity-50 mt-2"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}
